var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCollections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5C6 2.67 6.67 2 7.5 2H18.5C19.33 2 20 2.67 20 3.5V11.5C20 12.33 19.33 13 18.5 13H7.5C6.67 13 6 12.33 6 11.5V3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5C3 7.67 3.67 7 4.5 7H5V11.5C5 12.88 6.12 14 7.5 14H17V14.5C17 15.33 16.33 16 15.5 16H4.5C3.67 16 3 15.33 3 14.5V8.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5C4 18.67 4.67 18 5.5 18H16.5C17.33 18 18 18.67 18 19.5V20.5C18 21.33 17.33 22 16.5 22H5.5C4.67 22 4 21.33 4 20.5V19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollections);
export default __webpack_public_path__ + "static/media/icon_collections.dfca1359ccf0f41fa198e99f7b66159c.svg";
export { ForwardRef as ReactComponent };